import React, { useState, useEffect } from 'react';

const DigitalClock = () => {
  const [time, setTime] = useState(new Date());

  useEffect(() => {
    const timer = setInterval(() => setTime(new Date()), 1000);
    return () => clearInterval(timer);
  }, []);

  const hours = time.getHours().toString().padStart(2, '0');
  const minutes = time.getMinutes().toString().padStart(2, '0');
  const seconds = time.getSeconds().toString().padStart(2, '0');

  return (
    <div className="flex items-center gap-0.5 font-mono text-xs tabular-nums" data-testid="digital-clock">
      <span className="text-[#00F0FF]">{hours}</span>
      <span className="text-[#00F0FF]/50 animate-pulse">:</span>
      <span className="text-[#00F0FF]">{minutes}</span>
      <span className="text-[#00F0FF]/50 animate-pulse">:</span>
      <span className="text-[#00F0FF]/40">{seconds}</span>
    </div>
  );
};

export default DigitalClock;
